import {
  PersonActivityCreatedPayload,
  PersonActivityMigratedPayload,
  PersonActivityRemovedPayload,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createPersonActivityMessageHandler(
  eventEmitter: IEventEmitter,
) {
  return (
    action: WebSocketAction,
    item:
      | PersonActivityMigratedPayload
      | PersonActivityCreatedPayload
      | PersonActivityRemovedPayload,
  ) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(
            `[PersonActivityHandler] INSERT PersonActivity ${item.personId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.PersonActivity,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(
            `[PersonActivityHandler] MODIFY PersonActivity ${item.personId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.PersonActivity,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(
            `[PersonActivityHandler] REMOVE PersonActivity ${item.personId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.PersonActivity,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.debug(
            '[PersonActivityHandler] Ignoring action for PersonActivity:',
            action,
          );
      }
    } catch (error) {
      log.error('[PersonActivityHandler] Handler failed:', error);
    }
  };
}
